import { ApiError } from '../services/api.error';

export interface UploadErrorMessages {
  invalidType: string;
  tooLarge: string;
  tooMany: string;
  quotaExceeded: string;
  invalidData: string;
}

export const resolveUploadErrorMessage = (
  error: unknown,
  messages: UploadErrorMessages,
): string | null => {
  if (!(error instanceof ApiError)) return null;
  if (error.hasErrorCode('upload_invalid_image_type')) return messages.invalidType;
  if (error.hasErrorCode('upload_file_too_large')) return messages.tooLarge;
  if (error.hasErrorCode('upload_too_many_files')) return messages.tooMany;
  if (error.hasErrorCode('upload_storage_quota_exceeded')) return messages.quotaExceeded;
  if (error.hasErrorCode('upload_invalid_data')) return messages.invalidData;
  return null;
};
